import React from 'react';
import { UserPlus } from 'lucide-react';
import { Company } from './companyType';
import { Button } from '../components/ui/button';
import { Alert } from '../components/ui/alert';

interface ExistingCompanyViewProps {
  company: Company;
  onCreateAccount: () => void;
}

const ExistingCompanyView: React.FC<ExistingCompanyViewProps> = ({ company, onCreateAccount }) => {
  return (
    <div className="space-y-6">
      <h1 className="page-heading">Existing Company Profile</h1>
      
      {/* Info Alert */}
      <Alert variant="info">
        Your company profile is displayed below. Please click the "Create Online Account" button to create an account.
        If you have already created an account, please click "Login" at the top right corner.
      </Alert>

      {/* Company Details Card */}
      <div className="bg-white rounded-lg border border-gray-200 p-6 space-y-4">
        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Name:</span>
          <span className="text-paragraph">{company.name}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Line of Business:</span>
          <span className="text-paragraph">{company.line_of_business}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Address 1:</span>
          <span className="text-paragraph">{company.address_1}</span>
        </div>

        {company.address_2 && (
          <div className="grid grid-cols-[140px_1fr] gap-3">
            <span className="font-semibold text-foreground">Address 2:</span>
            <span className="text-paragraph">{company.address_2}</span>
          </div>
        )}

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">City:</span>
          <span className="text-paragraph">{company.city}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">State:</span>
          <span className="text-paragraph">{company.state}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Zip:</span>
          <span className="text-paragraph">{company.zip}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Phone:</span>
          <span className="text-paragraph">{company.phone}</span>
        </div>

        <div className="grid grid-cols-[140px_1fr] gap-3">
          <span className="font-semibold text-foreground">Email:</span>
          <span className="text-paragraph">{company.email}</span>
        </div>

        {company.web_url && (
          <div className="grid grid-cols-[140px_1fr] gap-3">
            <span className="font-semibold text-foreground">Website:</span>
            <span className="text-paragraph">{company.web_url}</span>
          </div>
        )}
      </div>

      <div >
        <Button onClick={onCreateAccount} size="medium" variant="default">
          <UserPlus className="size-5" />
          Create Online Account
        </Button>
      </div>
    </div>
  );
};

export default ExistingCompanyView;